module.exports = __webpack_public_path__ + "img/offer-sent-icon.685df70f.svg";